module.exports = __webpack_public_path__ + "img/icon4.047248ff.1a2061e1.png";